import {
  REQUEST_FETCH_PASSENGER,
  FETCH_PASSENGER_SUCCESS,
  FETCH_PASSENGER_ERROR,
  INITIAL_STATE_PASSENGER,
} from "../../../actions/reservations/passenger/fetchPassengerDetail";

const initialState = {
  passenger: {},
  fetching: false,
  message: "",
  error: "",
};

const passengerDetailReducer = (state = initialState, action) => {
  switch (action.type) {
    case INITIAL_STATE_PASSENGER: {
      return {
        ...state,
        passenger: {},
        processing: false,
        fetching: false,
        message: "",
        error: "",
      };
    }
    case REQUEST_FETCH_PASSENGER: {
      return {
        ...state,
        passenger: {},
        fetching: true,
        message: "",
        error: "",
      };
    }
    case FETCH_PASSENGER_SUCCESS: {
      return {
        ...state,
        passenger: action.passenger,
        fetching: false,
        message: "",
        error: "",
      };
    }
    case FETCH_PASSENGER_ERROR: {
      return {
        ...state,
        passenger: {},
        fetching: false,
        message: "",
        error: action.error,
      };
    }
    default: {
      return state;
    }
  }
};
export default passengerDetailReducer;
